import { render, staticRenderFns } from "./ReserveList.vue?vue&type=template&id=581972ee"
import script from "./ReserveList.vue?vue&type=script&lang=js"
export * from "./ReserveList.vue?vue&type=script&lang=js"
import style0 from "./ReserveList.vue?vue&type=style&index=0&id=581972ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports